import React from "react"
import { connect } from "react-redux"
import { chakra, Flex, Box } from "@chakra-ui/react"
import { FiPlus, FiMinus } from "react-icons/fi"
import { ganttSizeUpdate } from "../../redux/actions/settings"

import { ganttDurationUpdate } from "../../redux/actions/settings"

const GanttChartResize = ({ settings, dispatch }) => {
  //=================================================================

  const { ganttDurationOptions, ganttDurationIndex } = settings

  const onClickDuration = (e) => {
    e.preventDefault()
    dispatch(ganttDurationUpdate())
  }

  const onClickPlus = (e) => {
    e.preventDefault()
    let payload = { deltaBoxW: +1 }
    dispatch(ganttSizeUpdate(payload))
  }

  const onClickMinus = (e) => {
    e.preventDefault()
    let payload = { deltaBoxW: -1 }
    dispatch(ganttSizeUpdate(payload))
  }

  //-----------------------------------------------------------------

  //=================================================================
  return (
    <Flex justify="flex-end" align="flex-start">
      <chakra.button onClick={onClickDuration} outline="none" pr={4}>
        {ganttDurationOptions[ganttDurationIndex]}
      </chakra.button>
      <chakra.button onClick={onClickMinus} outline="none">
        <Box>
          <FiMinus />
        </Box>
      </chakra.button>
      <chakra.button onClick={onClickPlus} ml={2} outline="none" pr={4}>
        <Box>
          <FiPlus />
        </Box>
      </chakra.button>
    </Flex>
  )
}

const mapStateToProps = (state) => {
  return {
    settings: state.settings,
  }
}

export default connect(mapStateToProps)(GanttChartResize)
